import { render, staticRenderFns } from "./team_draw.vue?vue&type=template&id=374b8afc&scoped=true&"
import script from "./team_draw.vue?vue&type=script&lang=js&"
export * from "./team_draw.vue?vue&type=script&lang=js&"
import style0 from "./team_draw.vue?vue&type=style&index=0&id=374b8afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b8afc",
  null
  
)

export default component.exports